import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/lighvideo/clock.svg'
import _imports_1 from '../assets/lighvideo/number.svg'
import _imports_2 from '../assets/lighvideo/share.svg'
import _imports_3 from '../assets/lighvideo/language.svg'
import _imports_4 from '../assets/lighvideo/landown.svg'
import _imports_5 from '../assets/lighvideo/down.svg'
import _imports_6 from '../assets/lighvideo/expression.svg'
import _imports_7 from '../assets/lighvideo/photo.svg'
import _imports_8 from '../assets/lighvideo/user.svg'
import _imports_9 from '../assets/lighvideo/list.svg'


const _withScopeId = n => (_pushScopeId("data-v-368b8fb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ligh_home" }
const _hoisted_2 = { class: "ligh_header" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "ligh_title" }
const _hoisted_6 = { class: "title_content display_flx" }
const _hoisted_7 = { class: "content_left" }
const _hoisted_8 = { class: "map" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "title_text_top" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "state" }, "预告", -1))
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"title_text_bottom display_flx\" data-v-368b8fb3><div class=\"time\" data-v-368b8fb3><img src=\"" + _imports_0 + "\" data-v-368b8fb3><span data-v-368b8fb3>2020-02-20 20:20</span></div><div class=\"number\" data-v-368b8fb3><img src=\"" + _imports_1 + "\" data-v-368b8fb3><span class=\"people_sum\" data-v-368b8fb3>25.21万人次</span></div></div>", 1)
const _hoisted_15 = { class: "content_right display_flx" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"share\" data-v-368b8fb3><img src=\"" + _imports_2 + "\" data-v-368b8fb3><span data-v-368b8fb3>分享</span></div><div class=\"language\" data-v-368b8fb3><img class=\"language_img\" src=\"" + _imports_3 + "\" data-v-368b8fb3><span data-v-368b8fb3>中文</span><img src=\"" + _imports_4 + "\" data-v-368b8fb3></div>", 2)
const _hoisted_18 = { class: "person" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "神秘网友", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "down",
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_22 = { class: "video_chat" }
const _hoisted_23 = { class: "video" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "chat" }
const _hoisted_26 = { class: "button_box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div_" }, "在线成员", -1))
const _hoisted_28 = { class: "chat_content" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chat_message" }, null, -1))
const _hoisted_30 = { class: "qun_input" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"top\" data-v-368b8fb3><div class=\"img_group display_flx\" data-v-368b8fb3><div class=\"express\" data-v-368b8fb3><img src=\"" + _imports_6 + "\" data-v-368b8fb3></div><div class=\"photo\" data-v-368b8fb3><img src=\"" + _imports_7 + "\" data-v-368b8fb3></div><div class=\"user\" data-v-368b8fb3><img src=\"" + _imports_8 + "\" data-v-368b8fb3></div><div class=\"list\" data-v-368b8fb3><img src=\"" + _imports_9 + "\" data-v-368b8fb3></div></div></div>", 1)
const _hoisted_32 = { class: "intro" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro_text" }, "活动简介", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("img", {
          draggable: "false",
          src: _ctx.customData.top_logo_url,
          alt: ""
        }, null, 8, _hoisted_4), [
          [_vShow, _ctx.customData.top_logo_url]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("img", {
              draggable: "false",
              src: _ctx.customData.logo_url
            }, null, 8, _hoisted_9), [
              [_vShow, _ctx.customData.logo_url]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.title), 1),
              _hoisted_13
            ]),
            _hoisted_14
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("img", {
              class: "avatar",
              draggable: "false",
              src: _ctx.customData.logo_url,
              alt: ""
            }, null, 8, _hoisted_19), [
              [_vShow, _ctx.customData.logo_url]
            ]),
            _hoisted_20,
            _hoisted_21
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("img", {
          draggable: "false",
          src: _ctx.customData.video_url,
          alt: ""
        }, null, 8, _hoisted_24)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", {
            class: "changebg div_",
            style: _normalizeStyle({ backgroundColor: _ctx.childclo ? _ctx.childclo : '#00ccb0' })
          }, "聊天互动", 4),
          _hoisted_27
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", {
              class: "button",
              style: _normalizeStyle({ background: _ctx.childclo ? _ctx.childclo : '#05d3b' })
            }, "发送", 4)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", {
        class: "intro_title",
        style: _normalizeStyle({
          borderColor: _ctx.childclo ? _ctx.childclo : '#00ccb0',
          color: _ctx.childclo ? _ctx.childclo : '#00ccb0',
        })
      }, " 活动简介 ", 4),
      _hoisted_33
    ])
  ]))
}